import { isPlatformBrowser } from "@angular/common";
import { Inject, Pipe, PipeTransform, PLATFORM_ID } from "@angular/core";

@Pipe({
  name: "smileyConverter",
  pure: true
})
export class SmileyConverterPipe implements PipeTransform {
  private readonly smileyPath = "https://cdn.astrobin.com/static/astrobin/emoticons/";

  // Copied from CKEditorService
  private readonly smileyDescriptions: string[] = [
    "angel",
    "angry-1",
    "angry",
    "arrogant",
    "bored",
    "confused",
    "cool-1",
    "cool",
    "crying-1",
    "crying-2",
    "crying",
    "cute",
    "embarrassed",
    "emoji",
    "greed",
    "happy-1",
    "happy-2",
    "happy-3",
    "happy-4",
    "happy-5",
    "happy-6",
    "happy-7",
    "happy",
    "in-love",
    "kiss-1",
    "kiss",
    "laughing-1",
    "laughing-2",
    "laughing",
    "muted",
    "nerd",
    "sad-1",
    "sad-2",
    "sad",
    "scare",
    "serious",
    "shocked",
    "sick",
    "sleepy",
    "smart",
    "surprised-1",
    "surprised-2",
    "surprised-3",
    "surprised-4",
    "surprised",
    "suspicious",
    "tongue",
    "vain",
    "wink-1",
    "wink"
  ];

  private readonly smileyImages: string[] = [
    "angel.png",
    "angry-1.png",
    "angry.png",
    "arrogant.png",
    "bored.png",
    "confused.png",
    "cool-1.png",
    "cool.png",
    "crying-1.png",
    "crying-2.png",
    "crying.png",
    "cute.png",
    "embarrassed.png",
    "emoji.png",
    "greed.png",
    "happy-1.png",
    "happy-2.png",
    "happy-3.png",
    "happy-4.png",
    "happy-5.png",
    "happy-6.png",
    "happy-7.png",
    "happy.png",
    "in-love.png",
    "kiss-1.png",
    "kiss.png",
    "laughing-1.png",
    "laughing-2.png",
    "laughing.png",
    "muted.png",
    "nerd.png",
    "sad-1.png",
    "sad-2.png",
    "sad.png",
    "scare.png",
    "serious.png",
    "shocked.png",
    "sick.png",
    "sleepy.png",
    "smart.png",
    "surprised-1.png",
    "surprised-2.png",
    "surprised-3.png",
    "surprised-4.png",
    "surprised.png",
    "suspicious.png",
    "tongue.png",
    "vain.png",
    "wink-1.png",
    "wink.png"
  ];

  private readonly smileyMap: Map<string, { image: string; description: string }>;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    // Build a map for faster lookups
    this.smileyMap = new Map();
    for (let i = 0; i < this.smileyDescriptions.length; i++) {
      this.smileyMap.set(this.smileyDescriptions[i].toLowerCase(), {
        image: this.smileyImages[i],
        description: this.smileyDescriptions[i]
      });
    }
  }

  transform(value: string): string {
    // Return empty string for null/undefined
    if (!value) {
      return "";
    }

    // Return original value on server
    if (!isPlatformBrowser(this.platformId)) {
      return value;
    }

    // Regular expression to match :smiley_name: patterns
    // Matches colon, followed by word characters/hyphens/numbers, followed by colon
    const smileyRegex = /:([a-zA-Z0-9_-]+):/g;

    return value.replace(smileyRegex, (match, smileyName) => {
      const lowerSmileyName = smileyName.toLowerCase();
      const smileyData = this.smileyMap.get(lowerSmileyName);

      if (smileyData) {
        // Create the img tag with same attributes as CKEditor
        const src = this.smileyPath + smileyData.image;
        return `<img src="${src}" class="smiley" alt="${smileyData.description}" title="${smileyData.description}" />`;
      }

      // If no match found, return the original text
      return match;
    });
  }
}
